import { notify } from 'legacy-packages/ft-cb';
import { getConfirmationMessage } from 'chameleon/ui-stack/utilities/copy';

const sessionExpirationNotification = (
  expirationTimeDiff,
  timer,
  onCancelClick = () => {},
) => {
  const confirmationMessage = getConfirmationMessage(expirationTimeDiff, timer);
  notify.cta('Warning: Session Expiring', confirmationMessage, {
    confirmButtonText: 'RE-ENTER PASSWORD',
    cancelButtonText: 'IGNORE',
    onConfirm: () => {
      window.location.href = `${SSO_LOGIN_URL}?DURL=${window.location.href}`;
    },
    onCancel: () => onCancelClick(),
  });
};

export default sessionExpirationNotification;
